const rankingItems = [
  { rank: 1, title: '山海传说', type: '奇幻 / 动画', heat: '986万', trend: 'up', score: '9.5' },
  { rank: 2, title: '星际征途：新纪元', type: '科幻 / 冒险', heat: '872万', trend: 'up', score: '9.2' },
  { rank: 3, title: '暗夜守护者', type: '动作 / 超级英雄', heat: '815万', trend: 'up', score: '9.0' },
  { rank: 4, title: '迷雾追踪', type: '悬疑 / 犯罪', heat: '763万', trend: 'up', score: '8.8' },
  { rank: 5, title: '笑林外传', type: '喜剧 / 都市', heat: '698万', trend: 'down', score: '8.5' },
  { rank: 6, title: '深海迷城', type: '冒险 / 灾难', heat: '654万', trend: 'up', score: '8.6' },
  { rank: 7, title: '极速风暴', type: '动作 / 赛车', heat: '612万', trend: 'down', score: '8.3' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            电影排行榜
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-500">
            实时热门电影排行，热度数据每小时更新
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="rounded-xl bg-background-100 overflow-hidden">
            {rankingItems.map((item, idx) => (
              <a
                key={item.title}
                href="#cards"
                className={`flex items-center gap-3 md:gap-4 px-4 md:px-6 py-3 md:py-4 cursor-pointer hover:bg-background-200 transition-colors ${
                  idx < rankingItems.length - 1 ? 'border-b border-background-200' : ''
                }`}
              >
                <div className={`w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg font-bold font-label text-sm ${
                  item.rank === 1
                    ? 'bg-accent-500 text-white'
                    : item.rank === 2
                    ? 'bg-accent-400/80 text-white'
                    : item.rank === 3
                    ? 'bg-accent-300/80 text-white'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  {item.rank}
                </div>

                <div className="flex-1 min-w-0">
                  <h3 className="text-sm md:text-base font-bold font-heading text-foreground-900 truncate">
                    {item.title}
                  </h3>
                  <p className="text-xs text-foreground-500 mt-0.5">
                    {item.type}
                  </p>
                </div>

                <div className="text-right flex-shrink-0">
                  <div className="flex items-center gap-1 justify-end">
                    <span className="text-xs md:text-sm font-bold text-primary-500 font-label">
                      {item.score}
                    </span>
                    <span className="text-xs text-foreground-400">分</span>
                  </div>
                  <div className="flex items-center gap-1 justify-end mt-0.5">
                    <i className={`text-xs ${item.trend === 'up' ? 'ri-arrow-up-fill text-primary-500' : 'ri-arrow-down-fill text-foreground-400'}`}></i>
                    <span className="text-xs text-foreground-500">{item.heat}</span>
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}